import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Slider from 'react-slick';
import { AppTheme } from '../styles/AppTheme';
import { ProductTile } from './ProductTile';
import { AppHelper } from '../helpers/AppHelper';
import { Link } from 'react-router-dom';
import { AppConfig } from '../AppConfig';
import { CommonTheme, CommonStyles } from '../styles/Styles';
import Icon from '@material-ui/core/Icon';
import { PageAnalytics } from '../common/helpers/PageAnalytics';

export class ContactUsFooter extends Component {
  constructor(props) {
    super(props);
  }

  sendAnalytics = (action) => {
    PageAnalytics.gaTrkEvent(
      'general',
      action,
      this.props.cat || 'FOOTER',
      null)
  }


  render() {
    return (
      <div className={css(Styles.contentOuterContainer)}>
        <div className={css(Styles.contentContainer)}>
          <div className={css(Styles.contactUsContainer)}>
            <p className={css(Styles.mainTitle)}>
              CONTACT US
            </p>
            <div className={css(Styles.companyAddress)}>
              <p className={css(Styles.companyAddressText)}>
                {AppConfig.COMPANY_ADDRESS}
              </p>
              <div className={css(Styles.contactDetails)}>
                <a
                  onClick={() => this.sendAnalytics('phone')}
                  className={css(Styles.contactLink)}
                  href={'tel:' + AppConfig.SUPPORT_PHONE}>
                  <p className={css(Styles.contactText)} >
                    {AppConfig.SUPPORT_PHONE}
                  </p>
                </a>
                <p className={css(Styles.divider)}>|</p>
                <a
                  onClick={() => this.sendAnalytics('email')}
                  className={css(Styles.contactLink)}
                  href={'mailto:' + AppConfig.SUPPORT_EMAIL}>
                  <p className={css(Styles.contactText)} >
                    {AppConfig.SUPPORT_EMAIL}
                  </p>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className={css(Styles.contentSubContainer)}>
          <div className={css(Styles.socialMediaContainer)}>
            <p className={css(Styles.mainTitle)}>
              CONNECT WITH US
            </p>
            <div className={css(Styles.socialMediaIcons)}>
              <a
                className={css(Styles.imgContainer)}
                target='_blank' href='https://www.facebook.com/zepnurhealth/'>
                <img
                  src={require('../assets/images/facebook.svg')}
                  className={css(Styles.socialMediaImg)} />
              </a>
              <a
                className={css(Styles.imgContainer)}
                target='_blank' href='https://www.linkedin.com/company/zepnurhealth/'>
                <img
                  src={require('../assets/images/linked-in.svg')}
                  className={css(Styles.socialMediaImg)} />
              </a>

              <Link
                to={AppConfig.WHATSAPP_PHONE + encodeURI('I am interested in the product \n' + window.location.href)}
                target='_blank'
                onClick={() => this.sendAnalytics('whatsapp')}
                className={css(CommonStyles.link)}
              >
                <img
                  src={require('../assets/images/whatsapp.svg')}
                  className={css(CommonStyles.whtsAppImage)} />
              </Link>

              <Icon
                onClick={this.props.handleModal}
                className={css(Styles.footerContactIcon)}
                color='primary'>contact_support</Icon>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


const Styles = StyleSheet.create({
  contentOuterContainer: {
    display: 'flex',
    '@media (max-width: 767px)': {
      flexDirection: 'column',
    }
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'flex-start',
    '@media (max-width: 767px)': {
      justifyContent: 'center',
      alignItems: 'center'
    }
  },
  contactUsContainer: {
    display: 'flex',
    flexDirection: 'column',
    '@media (max-width: 767px)': {
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  mainTitle: {
    fontSize: 16,
    color: AppTheme.primaryColor,
    margin: '0px 0px 10px 0px',
    fontWeight: 'bolder',
    '@media (max-width: 767px)': {
      fontSize: 14,
    }
  },
  companyAddress: {
    display: 'flex',
    flexDirection: 'column',
    '@media (max-width: 767px)': {
      alignItems: 'center'
    }
  },
  companyAddressText: {
    color: CommonTheme.textColor,
    fontSize: 13,
    margin: 0,
    '@media (max-width: 767px)': {
      textAlign: 'center',
      fontSize: 12,
    }
  },
  contactDetails: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  contactLink: {
    textDecoration: 'none',
  },
  contactText: {
    color: '#4db0c5',
    fontSize: 13,
    '@media(max-width: 767px)': {
      fontSize: 12,
    },
  },
  divider: {
    fontSize: 13,
    margin: '0px 15px 0px 15px',
    '@media (max-width: 767px)': {
      margin: '0px 5px 0px 5px',
    }
  },
  contentSubContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    '@media (max-width: 767px)': {
      justifyContent: 'center',
      marginTop: 20
    }
  },
  socialMediaContainer: {
    display: 'flex',
    flexDirection: 'column',
    '@media (max-width: 767px)': {
      alignItems: 'center',
      justifyContent: 'center',
    }
  },
  socialMediaIcons: {
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 767px)': {
      justifyContent: 'center'
    }
  },
  imgContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  socialMediaImg: {
    width: 29,
    height: 29,
    marginRight: 5
  },
  footerContactIcon: {
    fontSize: 34,
    color: CommonTheme.color1,
    cursor: 'pointer',
  }
})


// WEBPACK FOOTER //
// ./src/components/ContactUsFooter.js